import { useState } from "react";
import { Cake, ImageOff } from "lucide-react";

const CODE_RE = /^[A-Za-z0-9]{6,8}$/;

export default function PhotoPage() {
    const [failed, setFailed] = useState(false);
    const code = window.location.pathname.split("/")[2] || "";
    const valid = CODE_RE.test(code);
    const src = `${process.env.REACT_APP_BACKEND_URL || ""}/api/p/${code}`;

    return (
        <div
            data-testid="photo-page"
            className="flex min-h-screen flex-col items-center justify-center gap-6 bg-cocoa p-6 text-center"
        >
            {valid && !failed ? (
                <img
                    src={src}
                    alt="Cake inspiration photo shared with Cakes'alot by Indu"
                    data-testid="photo-page-image"
                    onError={() => setFailed(true)}
                    className="max-h-[85vh] max-w-full rounded-3xl object-contain shadow-2xl"
                />
            ) : (
                <div data-testid="photo-page-error" className="text-cream">
                    <ImageOff className="mx-auto size-10 text-blush" />
                    <p className="mt-4 font-serif text-2xl">This photo isn't available</p>
                    <p className="mt-2 text-sm text-cream/60">
                        Check the link, or send your inspiration photos again with your
                        order.
                    </p>
                </div>
            )}
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-cream/50">
                <Cake className="size-4 text-blush" />
                Cakes'alot by Indu
            </p>
        </div>
    );
}
